import SpaceBetween from "@awsui/components-react/space-between";
import React from "react";
import {useTranslation} from "react-i18next";
import NavigationBar from "components/NavigationBar";
import Container from "@awsui/components-react/container";
import Header from "@awsui/components-react/header";
import Box from "@awsui/components-react/box";
import Link from "@awsui/components-react/link";


const AdminPage: React.FC = () => {
    const {t} = useTranslation("admin");
    return (
        <SpaceBetween size="l">
            <NavigationBar />
            <Container
                header={<Header>{t("adminPage")}</Header>}
            >
                <Container
                    header={<Header variant="h3">{t("sections.riders")}</Header>}
                >
                    <SpaceBetween size="m">
                        <Box>
                            <Link variant="primary" href="/admin/add_riders">{t("links.addRiders")}</Link>
                        </Box>
                        <Box>
                            <Link variant="primary" href="/admin/add_rider">{t("links.addRider")}</Link>
                        </Box>
                        <Box>
                            <Link variant="primary" href="/admin/set_basqueness">{t("links.setBasqueness")}</Link>
                        </Box>
                    </SpaceBetween>
                </Container>
                <Container
                    header={<Header variant="h3">{t("sections.points")}</Header>}
                >
                    <SpaceBetween size="m">
                        <Box>
                            <Link variant="primary" href="/admin/add_points">{t("links.addPoints")}</Link>
                        </Box>
                        <Box>
                            <Link variant="primary" href="/admin/recalculate_points">{t("links.recalculatePoints")}</Link>
                        </Box>
                        <Box>
                            <Link variant="primary" href="/admin/delete_points">{t("links.deletePoints")}</Link>
                        </Box>
                    </SpaceBetween>
                </Container>
                <Container
                    header={<Header variant="h3">{t("sections.competitions")}</Header>}
                >
                    <SpaceBetween size="m">
                        <Box>
                            <Link variant="primary" href="/admin/add_competition">{t("links.addCompetition")}</Link>
                        </Box>
                        <Box>
                            <Link variant="primary" href="/admin/edit_competition">{t("links.editCompetition")}</Link>
                        </Box>
                    </SpaceBetween>
                </Container>
                <Container
                    header={<Header variant="h3">{t("sections.questions")}</Header>}
                >
                    <SpaceBetween size="m">
                        <Box>
                            <Link variant="primary" href="/admin/add_question">{t("links.addQuestion")}</Link>
                        </Box>
                        <Box>
                            <Link variant="primary" href="/admin/select_answers">{t("links.selectAnswers")}</Link>
                        </Box>
                    </SpaceBetween>
                </Container>
                <Container
                    header={<Header variant="h3">{t("sections.synonyms")}</Header>}
                >
                    <SpaceBetween size="m">
                        <Box>
                            <Link variant="primary" href="/admin/add_rider_synonyms">{t("links.addRiderSynonyms")}</Link>
                        </Box>
                        <Box>
                            <Link variant="primary" href="/admin/add_rider_synonym">{t("links.addRiderSynonym")}</Link>
                        </Box>
                        <Box>
                            <Link variant="primary" href="/admin/add_team_synonyms">{t("links.addTeamSynonyms")}</Link>
                        </Box>
                    </SpaceBetween>
                </Container>
                <Container
                    header={<Header variant="h3">{t("sections.penalties")}</Header>}
                >
                    <SpaceBetween size="m">
                        <Box>
                            <Link variant="primary" href="/admin/add_penalty">{t("links.addPenalty")}</Link>
                        </Box>
                        <Box>
                            <Link variant="primary" href="/admin/remove_penalty">{t("links.removePenalty")}</Link>
                        </Box>
                    </SpaceBetween>
                </Container>
            </Container>
        </SpaceBetween>
    );
};

export default AdminPage;
